import { formatDate } from '../../../utils/formatDate';

export const parseSalary = (salaryString) => {
  if (!salaryString) return null;
  const match = salaryString.match(/[\d,]+/g);
  return match ? match.map(num => parseInt(num.replace(/,/g, ''))) : null;
};

export const filterJobsBySearch = (jobs, searchTerm) => {
  if (!searchTerm) return jobs;
  const term = searchTerm.toLowerCase();
  return jobs.filter(job =>
    job.title.toLowerCase().includes(term) ||
    job.category.toLowerCase().includes(term) ||
    job.city.toLowerCase().includes(term) ||
    job.description.toLowerCase().includes(term)
  );
};

export const sortJobs = (jobs, sortBy = 'newest') => {
  const sorted = [...jobs];
  switch (sortBy) {
    case 'oldest':
      return sorted.reverse();
    case 'price-high':
      return sorted.sort((a, b) => (b.price || 0) - (a.price || 0));
    case 'price-low':
      return sorted.sort((a, b) => (a.price || 0) - (b.price || 0));
    default:
      return sorted;
  }
};

export const truncateText = (text, max = 150) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max).trim()}...` : text;
};

export const formatPostedAt = (dateString) => formatDate(dateString);
